<template>
    <div>
        <transactions-count-chart :chart_data="chart_data.transactions_count_chart"></transactions-count-chart>
        <transactions-rate-chart :chart_data="chart_data.transactions_rate_chart"></transactions-rate-chart>
        <on-gateway-chart :chart_data="chart_data.on_gateway_time_chart"></on-gateway-chart>
        <verify-chart :chart_data="chart_data.verify_time_chart"></verify-chart>
        <token-chart :chart_data="chart_data.token_time_chart"></token-chart>
        <psp-scores-chart :chart_data="chart_data.psp_scores_chart"></psp-scores-chart>
    </div>
</template>
<script>
    import onGatewayChart from './on-gateway-chart'
    import verifyChart from './verify-chart'
    import tokenChart from './token-chart'
    import transactionsCountChart from './transactions-count-chart'
    import transactionsRateChart from './transactions-rate-chart'
    import pspScoresChart from './psp-scores-chart'

    export default {
        name: "chart",
        props: ["chart_data"],
        components: {
            onGatewayChart,
            verifyChart,
            tokenChart,
            transactionsCountChart,
            transactionsRateChart,
            pspScoresChart
        },
    };
</script>

<style>
    #chart {
        margin: auto;
    }
    .apexcharts-tooltip-text {
        text-align: right!important;
        width: 100%;
    }
    .apexcharts-tooltip-marker {
        margin-right: 1px !important;
        margin-left: 3px !important;
    }
    .apexcharts-tooltip-series-group {
        padding-right: 0 !important;
    }
    .apexcharts-tooltip-y-group {
        text-align: right!important;
        display: flex;
        justify-content: space-between;
    }
</style>